<footer class="footer">
  <div class="footer-content">
    <div class="footer-single-line">
      <!-- Brand & Copyright -->
      <div class="footer-brand-section">
        <span class="footer-brand">SOS Corp</span>
        <span class="footer-separator">|</span>
        <span class="copyright">
          {{ currentYear }} {{ 'footer.copyright' | translate }}
        </span>
      </div>

      <!-- Quick Links -->
      <nav class="footer-links-inline">
        @for (link of companyLinks; track link.route) {
        <a [routerLink]="link.route" class="footer-link">
          {{ link.labelKey | translate }}
        </a>
        }
      </nav>

      <!-- Social Links -->
      <div class="social-links">
        @for (social of socialLinks; track social.label) {
        <a
          [href]="social.url"
          target="_blank"
          rel="noopener noreferrer"
          [attr.aria-label]="social.label"
          class="social-link"
        >
          <img
            [src]="'assets/icons/' + social.icon + '.png'"
            [alt]="social.label + ' icon'"
            width="24"
            height="24"
          />
        </a>
        }
      </div>
    </div>
  </div>
</footer>
